import { Flex, useBreakpointValue } from '@chakra-ui/react'
import CharlesMeta from 'components/meta/CharlesMeta'
import AccordionNewSection from 'components/sections/AccordionNewSection'
import MedleveAboutSection from 'components/sections/MedleveAboutSection'
import MedleveBanner from 'components/sections/MedleveBanner'
import MedleveHeroSection from 'components/sections/MedleveHeroSection'
import MedleveHowItWorksSection from 'components/sections/MedleveHowItWorksSection'
import MedleveStickyCTA from 'components/sections/MedleveStickyCTA'
import { TestimoniesSection } from 'components/sections/TestimoniesSection'
import TypeformPreloader from 'components/sections/TypeformPreloader'
import WeightTestimoniesSection from 'components/sections/WeightTestimoniesSection'
import { Body1 } from 'components/typography'
import { LandingBasicLayout } from 'layouts/LadingLayout'
import { useRouter } from 'next/router'
import { FC, useEffect } from 'react'
import LazyLoad from 'react-lazyload'
import { setCookies } from 'utils/cookieHelpers'
import { medleveFaq } from 'utils/data/faq/medleveFaq'
import { medleveVideoTestimonies } from 'utils/data/testimonies'

const MedLevePage: FC = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false })
  const { pathname } = useRouter()
  const gads = pathname.includes('gads')
  useEffect(() => {
    setCookies({ name: 'isMedleveAddress', value: 'true' })
  }, [])
  return (
    <LandingBasicLayout>
      <CharlesMeta
        data={{
          title: 'Emagrecimento | MedLeve',
          description: gads ? 'Faça sua consulta online por R$69' : 'Obtenha a sua receita online e compra o seu GLP-1'
        }}
      />
      <MedleveHeroSection />
      {isMobile && <MedleveBanner />}

      <LazyLoad once unmountIfInvisible>
        <MedleveHowItWorksSection />
      </LazyLoad>

      <LazyLoad once unmountIfInvisible>
        <TestimoniesSection title="" testimonies={medleveVideoTestimonies} variant="medleve" />
      </LazyLoad>

      <LazyLoad once unmountIfInvisible>
        <MedleveAboutSection />
      </LazyLoad>

      <LazyLoad once unmountIfInvisible>
        <WeightTestimoniesSection medleve />
      </LazyLoad>

      {!gads && (
        <LazyLoad once unmountIfInvisible>
          <AccordionNewSection sections={medleveFaq} />
        </LazyLoad>
      )}

      {!gads && (
        <LazyLoad once unmountIfInvisible>
          <Flex align={'center'} justify={'center'} py={4} bg={'alabaster'}>
            <Body1>*A indicação e prescrição dos tratamentos estão sujeitas à avaliação médica.</Body1>
          </Flex>
        </LazyLoad>
      )}
      <MedleveStickyCTA />
      <TypeformPreloader typeformId={process.env.NEXT_PUBLIC_TYPEFORM_ID_PRE_ANALYSIS_MEDLEVE} />
    </LandingBasicLayout>
  )
}

export default MedLevePage
